var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.12500rem",
    height: "2.12500rem",
    viewBox: "0 0 99 99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zastupna-parsona-190613",
    transform: "translate(-164.000000, -248.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(108.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man-detail",
    transform: "translate(56.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5,99 C22.206,99 0,76.794 0,49.5 C0,22.206 22.206,0 49.5,0 C76.794,0 99,22.206 99,49.5 C99,76.794 76.794,99 49.5,99 Z M49.5,3 C23.859,3 3,23.859 3,49.5 C3,75.141 23.859,96 49.5,96 C75.141,96 96,75.141 96,49.5 C96,23.859 75.141,3 49.5,3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,99 C39.195,99 29.292,95.826 20.853,89.82 C20.403,89.499 20.163,88.95 20.235,88.401 C20.307,87.852 20.679,87.384 21.201,87.192 C33.639,82.587 35.646,78.849 35.646,71.685 C35.646,69.792 35.22,69.171 34.452,68.043 C33.435,66.561 32.043,64.53 31.065,59.226 C30.921,58.464 30.798,58.404 30.117,58.074 C28.299,57.198 26.628,55.938 26.19,50.19 C26.19,47.406 27.15,45.867 27.945,45.066 C27.771,44.076 27.486,42.369 27.219,40.509 C25.86,32.178 25.8,21.975 37.518,17.232 C47.73,13.092 55.881,15.354 58.44,18.051 C60.252,18.108 64.926,18.582 68.178,22.365 C73.182,28.185 71.589,41.454 71.043,45.051 C71.841,45.834 72.81,47.352 72.81,50.076 C72.372,55.938 70.701,57.201 68.88,58.074 C68.196,58.404 68.073,58.461 67.932,59.226 C66.954,64.53 65.565,66.561 64.548,68.043 C63.777,69.168 63.354,69.792 63.354,71.685 C63.354,78.849 65.361,82.587 77.799,87.192 C78.321,87.384 78.693,87.849 78.765,88.401 C78.837,88.953 78.597,89.499 78.147,89.82 C69.708,95.826 59.805,99 49.5,99 Z M24.951,88.953 C32.337,93.573 40.767,96 49.5,96 C58.233,96 66.663,93.573 74.049,88.953 C63.627,84.675 60.354,80.361 60.354,71.688 C60.354,68.865 61.188,67.644 62.073,66.351 C62.985,65.019 64.119,63.363 64.986,58.683 C65.403,56.421 66.714,55.791 67.581,55.374 C68.514,54.927 69.474,54.465 69.813,49.965 C69.81,47.673 68.781,47.049 68.739,47.025 C68.187,46.707 67.83,46.038 67.947,45.414 C68.691,41.427 69.915,28.992 65.904,24.321 C63.165,21.135 58.848,21.048 58.026,21.081 C57.888,21.069 57.753,21.066 57.624,21.033 C57.234,20.934 56.574,20.595 56.373,20.247 C55.557,18.849 48.45,16.038 38.643,20.007 C28.95,23.931 28.929,32.343 30.186,40.053 C30.6,42.924 31.053,45.405 31.056,45.417 C31.179,46.092 30.828,46.764 30.207,47.049 C30.216,47.049 29.19,47.676 29.19,50.073 C29.526,54.456 30.489,54.921 31.419,55.368 C32.286,55.785 33.6,56.415 34.017,58.677 C34.881,63.357 36.015,65.013 36.927,66.345 C37.815,67.638 38.649,68.859 38.649,71.682 C38.649,80.364 35.376,84.678 24.951,88.953 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonaIcon);
export default __webpack_public_path__ + "static/media/PersonaIcon.acb5985a75c55119f81624e264f29bb9.svg";
export { ForwardRef as ReactComponent };